import { ArrowRight } from 'lucide-react'
import { Link } from 'react-router-dom'

import { Card, CardContent } from '@/customer/components/ui/card'
import type { OnboardingIssue } from '@/customer/lib/membership'
export function NextStepsChecklist({
  issues,
  description,
  replaceOnNavigate,
}: {
  issues: OnboardingIssue[]
  /**
   * Sub-copy under the "Next steps" heading. Defaults to the
   * account-home framing; callers with a more specific context (e.g.
   * the welcome page, which knows the pet just subscribed) can pass
   * their own wording.
   */
  description?: string
  /** Use `history.replaceState` for checklist links so the current page drops out of the back stack. */
  replaceOnNavigate?: boolean
}) {
  return (
    <Card color="green" className="bg-green/30">
      <CardContent>
        <div className="flex flex-col">
          <p className="text-body-lg font-bold">Next steps</p>
          <p className="text-body-md">
            {description ?? 'A few things to complete before you can book.'}
          </p>
        </div>
        <ul className="flex flex-col gap-3">
          {issues.map((item) => (
            <li key={`${item.type}:${item.action.href}`}>
              <Link
                to={item.action.href}
                replace={replaceOnNavigate}
                className="group -mx-2 flex items-center gap-3 rounded-lg px-2 py-1 transition-colors hover:bg-foreground/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
              >
                <span className="flex-1">
                  <span className="block text-body-md font-semibold">{item.title}</span>
                  <span className="block text-fine-print">{item.description}</span>
                </span>
                <ArrowRight
                  className="size-4 shrink-0 transition-transform group-hover:translate-x-0.5"
                  aria-hidden
                />
              </Link>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  )
}
